import {
  InvalidateOptions,
  InvalidateQueryFilters,
  QueryClient,
  QueryClientConfig,
} from '@tanstack/react-query';
import { getDefaultStore } from 'jotai/vanilla';
import { queryClientAtom } from 'jotai-tanstack-query';

import { is403Error } from '@cast/api-client';

import { setupDemoStateQueryInvalidation } from '@cast/infrastructure-demo';
import { isE2E } from '@cast/utils';

export const getQueryClient = (config: QueryClientConfig) =>
  new QueryClient(config);

const clientConfig: QueryClientConfig = {
  defaultOptions: {
    queries: {
      staleTime: 20_000,
      gcTime: 20_000,
      // Disables retries in E2E/integration tests for faster tests
      // when testing failures
      // Also disables retries for 403 errors (access forbidden)
      retry: (failureCount, error: any) => {
        // Stop retrying on 403 errors
        if (is403Error(error)) {
          return false;
        }
        // In E2E tests, disable retries completely
        if (isE2E()) {
          return false;
        }
        // Otherwise retry up to 4 times
        return failureCount < 4;
      },
    },
  },
};

export const queryClient = getQueryClient(clientConfig);

getDefaultStore().set(queryClientAtom, queryClient);

// Setup demo state query invalidation
setupDemoStateQueryInvalidation(queryClient);

// Expose query client invalidation for E2E tests
if (isE2E()) {
  window.invalidateQueries = (
    filters?: InvalidateQueryFilters<readonly unknown[]> | undefined,
    options?: InvalidateOptions
  ) => {
    return queryClient.invalidateQueries(filters, options);
  };
}
